import { Check } from "@phosphor-icons/react";
import Reveal from "@/components/landing/Reveal";
import { useI18n } from "@/lib/i18n";

export default function AppPreview() {
  const { t } = useI18n();
  const items = t("preview.highlights") || [];
  return (
    <section
      id="app-preview"
      data-testid="app-preview-section"
      className="relative py-24 sm:py-32 bg-emerald-950 text-stone-50 overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0 -z-0">
        <div className="absolute -top-32 -left-24 h-[28rem] w-[28rem] rounded-full bg-emerald-700/30 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-[24rem] w-[24rem] rounded-full bg-orange-500/15 blur-3xl" />
        <div className="absolute inset-0 grain opacity-[0.4] mix-blend-screen" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-emerald-300">
              {t("preview.kicker")}
            </div>
            <h2 className="mt-4 font-display font-bold text-4xl sm:text-5xl tracking-tight leading-tight text-balance">
              {t("preview.h2")}
            </h2>
            <p className="mt-5 text-lg text-stone-200/85 leading-relaxed">
              {t("preview.lead")}
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <Reveal key={it.title} delay={i * 0.08}>
              <article
                data-testid={`app-highlight-${i}`}
                className="h-full rounded-3xl border border-emerald-400/10 bg-emerald-900/30 backdrop-blur-sm p-7 sm:p-8 flex flex-col"
              >
                <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-emerald-300">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="mt-3 font-display font-semibold text-xl sm:text-2xl text-stone-50">
                  {it.title}
                </h3>
                <p className="mt-3 text-[15px] text-stone-300 leading-relaxed">
                  {it.description}
                </p>
                <ul className="mt-6 space-y-3 pt-5 border-t border-emerald-400/10">
                  {it.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2.5 text-sm text-stone-200 leading-relaxed">
                      <span className="mt-1 h-4 w-4 rounded-full bg-emerald-400/15 inline-flex items-center justify-center shrink-0">
                        <Check size={11} weight="bold" className="text-emerald-300" />
                      </span>
                      {b}
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

// AppPreview component end
